/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EnumsDtoOut
 */
export interface EnumsDtoOut {
    /**
     * 
     * @type {Array<string>}
     * @memberof EnumsDtoOut
     */
    errorTypes: Array<EnumsDtoOutErrorTypesEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum EnumsDtoOutErrorTypesEnum {
    InvalidOtp = 'INVALID_OTP',
    PhoneNumberParse = 'PHONE_NUMBER_PARSE',
    MaxUploadSizeExceeded = 'MAX_UPLOAD_SIZE_EXCEEDED',
    CouldNotDeliverOtp = 'COULD_NOT_DELIVER_OTP',
    InvalidData = 'INVALID_DATA',
    PatientNotFoundInIkem = 'PATIENT_NOT_FOUND_IN_IKEM',
    CaptchaVerificationFailed = 'CAPTCHA_VERIFICATION_FAILED'
}



